import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";
import TryItButton from "../../../TryItButton";
import OutputBox from "../../../OutputBox";

export default function JS_If() {
  return (
    <div className="tutorial-container read-only">
      <h1 className="tutorial-title">🟢 JavaScript if Statement</h1>

      <p className="tutorial-intro">
        The <code className="highlight_code">if</code> statement checks a single
        condition in JavaScript. If the condition is true, the code inside runs
        — otherwise, it’s skipped. It’s great for simple checks like “If it’s
        raining, carry an umbrella.”
      </p>

      <div
        className="Key_point_container"
        style={{ background: "linear-gradient(135deg, #dcfce7, #bbf7d0)" }}
      >
        <h2 style={{ color: "#166534" }}>🔑 Key Points</h2>
        <ul className="tutorial-list-points">
          <li>Executes code only if a condition is true.</li>
          <li>Best for single-condition decisions.</li>
          <li>Helps control logical flow in programs.</li>
        </ul>
      </div>

      {/* Example 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">1️⃣ Simple Login Check</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let isLoggedIn = true;
if (isLoggedIn) {
  console.log("Welcome to Edu-Tech Master Academy!");
}`}
          />
          <TryItButton
            code={`let isLoggedIn = true;
if (isLoggedIn) {
  console.log("Welcome to Edu-Tech Master Academy!");
}`}
          />
        </div>
        <OutputBox>
          <pre>Welcome to Edu-Tech Master Academy!</pre>
        </OutputBox>
      </div>

      {/* Example 2 */}
      <div className="tutorial-section">
        <h2 className="section-title">2️⃣ Exam Eligibility</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let marks = 65;
if (marks >= 50) {
  console.log("You passed the test at Edu-Tech Master Academy!");
}`}
          />
          <TryItButton
            code={`let marks = 65;
if (marks >= 50) {
  console.log("You passed the test at Edu-Tech Master Academy!");
}`}
          />
        </div>
        <OutputBox>
          <pre>You passed the test at Edu-Tech Master Academy!</pre>
        </OutputBox>
      </div>

      {/* Example 3 */}
      <div className="tutorial-section">
        <h2 className="section-title">3️⃣ Course Access</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let hasSubscription = true;
if (hasSubscription) {
  console.log("Access granted to premium Edu-Tech Master Academy courses.");
}`}
          />
          <TryItButton
            code={`let hasSubscription = true;
if (hasSubscription) {
  console.log("Access granted to premium Edu-Tech Master Academy courses.");
}`}
          />
        </div>
        <OutputBox>
          <pre>Access granted to premium Edu-Tech Master Academy courses.</pre>
        </OutputBox>
      </div>

      {/* Next Steps */}
      <div
        style={{
          background: "linear-gradient(135deg, #d9f99d, #bef264)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2 style={{ color: "#365314" }}>🚀 Next Steps</h2>
        <ul className="tutorial-list-points">
          <li>Practice writing simple conditions (like login checks).</li>
          <li>Combine multiple if statements for layered logic.</li>
          <li>
            Learn <code className="highlight_code">if...else</code> for handling
            “either/or” cases.
          </li>
          <li>Explore ternary operators for short decisions.</li>
        </ul>
      </div>
    </div>
  );
}
